import { render, staticRenderFns } from "./OfferDetailPremium.vue?vue&type=template&id=6a064000"
import script from "./OfferDetailPremium.vue?vue&type=script&lang=js"
export * from "./OfferDetailPremium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports